import { render, staticRenderFns } from "./newPost.vue?vue&type=template&id=2718920f&scoped=true"
import script from "./newPost.vue?vue&type=script&lang=js"
export * from "./newPost.vue?vue&type=script&lang=js"
import style0 from "./newPost.vue?vue&type=style&index=0&id=2718920f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718920f",
  null
  
)

export default component.exports